module.exports = __webpack_public_path__ + "media/images/crypto-currencies/cardano-1825f13cdf9785e16fd5b6be9043ddd2.svg";